import clsx from 'clsx'

interface Props {
  class?: string
  title: string
  statistics: {
    stat: string
    color: string | null
    description?: string
  }[]
  mode?: 'dark' | 'green'
}

function Statistics({
  mode = 'dark',
  title,
  statistics,
  ...props
}: Props): JSX.Element {
  return (
    <section
      className={clsx(
        props.class,
        mode === 'dark'
          ? 'bg-blue-web-90 text-white'
          : 'bg-green-30 text-blue-web-90',
        'font-heading'
      )}
    >
      <div className="container | grid grid-cols-4 md:grid-cols-12 gap-8 items-center | py-10 md:py-18">
        <div className="md:max-w-col-6 col-span-4 md:col-span-6 md:justify-self-end">
          {title ? (
            <h2
              className="text-3xl lg:text-6xl font-medium"
              dangerouslySetInnerHTML={{ __html: title }}
            ></h2>
          ) : null}
        </div>
        <div className="md:max-w-col-4 col-span-4 md:col-span-4 md:col-start-8 | flex flex-col gap-7 lg:gap-14">
          {statistics?.map((statistic, index) => (
            <div
              key={`statistic_${index}`}
              className={clsx(
                mode === 'dark' ? 'border-gray-50' : 'border-blue-web-90',
                'border-b'
              )}
            >
              <h3
                className="text-3xl lg:text-5xl font-medium | mb-1"
                style={{ color: `${mode === 'dark' ? statistic.color : null}` }}
                dangerouslySetInnerHTML={{ __html: statistic.stat }}
              />

              <span
                className="text-base lg:text-2xl inline-block | mb-2 md:mb-5"
                dangerouslySetInnerHTML={{
                  __html: statistic.description ?? ''
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Statistics
